import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { campaigns } from "../../../../../../redux/campaigns/action";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import TabContainer from "../../../../../../common/components/tab/containers/tab.containers";
import { emailCampaigns } from "../../../../../../redux/email-campaigns/action";
import { selectEmailCampaignsListItems } from "../../../../../../redux/email-campaigns/selector";
import DSAPAgencySMSMarketingCampaigns from "./sms-campaigns";
import { selectListItems } from "../../../../../../redux/library/selector";

const AgencyMarketingCampaigns = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
const libraryData = useSelector(selectListItems)
    const itemsData = useSelector(selectEmailCampaignsListItems)
    const [
        columnDefsEmail,
        setColumnDefsEmail
      ] = useState({});
      const createColumnDefsEmail: any = () => {
        setColumnDefsEmail([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name',isEdit: true },
          { field: 'FrequencyId', headerName: 'Frequency Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.CampaignFrequency} ,sortable: true,filter: false },
          { field: 'StartDate', headerName: 'Start Date', isDateValueFormat:true },
          { field: 'EndDate', headerName: 'End Date', isDateValueFormat:true}
         
        ]);
      }

  const handleAdd=()=>{
    navigate(`${0}`)
  }

  const handleEdit=(data: any)=>{  
    navigate(`${data?.Id}`)
  }

  const handleDelete=(data: any)=>{
    dispatch(emailCampaigns.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns/delete`,
      entity: 'emailCampaigns',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(async () => {
    await dispatch(emailCampaigns.resetAction({ actionType: 'list' }));
    await dispatch(emailCampaigns.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns/list`,entity:'emailCampaigns',jsonData:{
  
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",
  
      }}))
  });
  }

  const additionButtons: any = [
    {
      name: 'Add New Email Campaign',
      callback: () => handleAdd(),
    }
  ];


  const fetchEmailCampaigns=async ()=>{
    await dispatch(emailCampaigns.resetAction({ actionType: 'list' }));
   await  dispatch(emailCampaigns.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns/list`,entity:'emailCampaigns',jsonData:{
  
    "PageNumber": pageData,
    "PageSize": pageSize,
    "SortField": "Id",
    "SortOrder": "desc",

    }}))
  
  }
  useEffect(() => {

      createColumnDefsEmail()
      // fetchCampaigns()
      fetchEmailCampaigns();
  }, [pageData,pageSize])



  const tabItems = [
    {
      id: 1,
      title: 'Email',
      component: <>
      <Table 
          columnData={columnDefsEmail} 
          rowData={itemsData?.result?.items} 
          setPageData={setPageData} 
          setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination} 
          onEdit={handleEdit} 
          onDelete={handleDelete} 
          additionButtons={additionButtons} 
          headingName="Campaigns" 
        />
      </>,
      isVisible: true,
    },
    {
      id: 2,
      title: 'SMS',
      component: <DSAPAgencySMSMarketingCampaigns/>,
      isVisible: true,
    },
  //   {
  //     id: 3,
  //     title: 'Whatsapp',
  //     component: <>Whatsapp Campaign</>,
  //     isVisible: true,
  //   },
  //   {
  //     id: 4,
  //     title: 'Facebook',
  //     component: <>Facebook Campaign</>,
  //     isVisible: true,
  // },
  ]

  return (
    <>
      {itemsData?.isLoading ?
        <PageLoader /> :
        // <Table 
        //   columnData={columnDefs} 
        //   rowData={itemsData?.result?.items} 
        //   setPageData={setPageData} 
        //   setPageSize={setPageSize}
        //   paginationData={itemsData?.result?.pagination} 
        //   onEdit={handleEdit} 
        //   onDelete={handleDelete} 
        //   additionButtons={additionButtons} 
        //   headingName="Campaigns" 
        // />
        <TabContainer tabItems={tabItems} />
      }
    </>
  );
};

export default AgencyMarketingCampaigns;


